import { createQueryKeys } from "@lukemorales/query-key-factory";
import { FramePreviewApi } from "mws-ts-v2-sdk";

import { getUniversalAxios } from "~/utils/axios/getUniversalAxios";

const getFramePreviewApi = () => {
  return new FramePreviewApi(
    undefined,
    useRuntimeConfig().public.ftgServiceUrl,
    getUniversalAxios(),
  );
};

export const framingPreviewQueryKeys = createQueryKeys("framingPreviews", {
  list: (
    orderId: MaybeRefOrGetter<string>,
    currency: MaybeRefOrGetter<string>,
  ) => ({
    queryKey: [orderId, currency],
    queryFn: async () => {
      const response =
        await getFramePreviewApi().v2FramePreviewsExternalReferenceOrderIdGet({
          orderId: toValue(orderId),
          currency: toValue(currency),
        });

      return response.data;
    },
  }),
});
